import React, { useState } from "react";
import { Colors } from "../constants/Colors";
import { ArrowUp, ArrowDown } from "./Arrow";

/**
 *
 * @param {Object} props
 * @param {React.ReactNode} props.title
 * @param {React.ReactNode} props.content
 * @returns
 */
export const Accordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <button
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0.5rem",
          backgroundColor: Colors.primary20,
          border: "none",
          borderRadius: isOpen ? "5px 5px 0 0" : "5px",
          cursor: "pointer",
          width: "100%",
        }}
      >
        <span style={{ fontSize: "15px", fontWeight: 600 }}>{title}</span>
        {isOpen ? <ArrowUp /> : <ArrowDown />}
      </button>
      {isOpen && (
        <div
          style={{
            padding: "10px",
            backgroundColor: Colors.neutral5,
            borderRadius: "0 0 5px 5px",
            marginTop: "5px",
          }}
        >
          <div
            style={{
              color: "black",
              fontSize: "14px",
              lineHeight: "20px",
              textAlign: "justify",
              listStyleType: "disc",
            }}
          >
            {content}
          </div>
        </div>
      )}
    </div>
  );
};
